import { PageShell, Section } from "@/components/PageShell";

export default function RefundPolicy() {
  return (
    <PageShell
      title="Refund Policy"
      subtitle="Try it for 30 days. If it does not fit your routine, request a full refund."
      testid="refund-page"
    >
      <Section heading="30 day guarantee">
        <p>
          You can request a full refund within 30 days of your purchase. If the
          Command Center does not fit your routine, we will refund your payment.
        </p>
      </Section>

      <Section heading="When the period begins">
        <p>
          The 30 day period begins on the date of your purchase, which is the
          date shown on your order confirmation.
        </p>
      </Section>

      <Section heading="How to request a refund">
        <p>
          Email
          {" "}
          <a href="mailto:support@commandcenteradhd.com" className="font-semibold text-[#A8D5F5] hover:text-white">
            support@commandcenteradhd.com
          </a>
          {" "}
          from the email address you used at checkout and let us know you would
          like a refund. You do not need to explain why.
        </p>
      </Section>

      <Section heading="What we need from you">
        <p>
          Please include the email address used for the purchase and, if you
          have it, your order confirmation or the approximate purchase date so
          we can locate your order quickly.
        </p>
      </Section>

      <Section heading="Processing time">
        <p>
          Once approved, refunds are issued to your original payment method.
          Processing usually completes within five to ten business days,
          depending on your payment provider and bank.
        </p>
      </Section>

      <Section heading="What happens to your access">
        <p>
          When a refund is issued, your paid access is withdrawn: your access
          link is deactivated and your community access is removed. The refund
          returns you to where you were before the purchase.
        </p>
      </Section>

      <Section heading="Exclusions">
        <p>
          Refund requests made after the 30 day period may not be eligible.
          Requests connected to sharing, copying, or redistributing the template
          in breach of the license may also be declined.
        </p>
      </Section>

      <Section heading="Support">
        <p>
          For any question about refunds, contact
          {" "}
          <a href="mailto:support@commandcenteradhd.com" className="font-semibold text-[#A8D5F5] hover:text-white">
            support@commandcenteradhd.com
          </a>
          .
        </p>
      </Section>
    </PageShell>
  );
}
